/**
 * Application-wide constants
 */

// API Endpoints (add your endpoints here as you build)
export const API_ENDPOINTS = {
  USER_REGISTER: '/api/v1/user/register',
  USER_ME: '/api/v1/user/me',
  USER_BY_UNIQUE_ID: '/api/v1/user/by-unique-id',
  USER_UPDATE_NAME: '/api/v1/user/me/name',
  ANALYSIS: '/api/v1/analyse',
  ANALYSIS_CSV: '/api/v1/analyse/csv',
  MCP_TOOLS: '/api/v1/mcp/tools',
} as const;

// App configuration
export const APP_CONFIG = {
  APP_NAME: 'NLP IBM Debater',
  VERSION: '0.1.0',
} as const;

// UI Constants
export const UI = {
  DEBOUNCE_DELAY: 300, // ms
  ANIMATION_DURATION: 200, // ms
} as const;

